<section class="risk-summary" [ngClass]="getStateClass()" *ngIf="isVisible()">
   <div class="risk-summary-heading">
      <div class="risk-summary-icon" aria-hidden="true">
         <i [ngClass]="getStateIconClass()"></i>
      </div>

      <div class="risk-summary-heading-content">
         <h3>{{ getStateTitle() }}</h3>

         <p class="risk-state-message" *ngIf="!isRiskState() && getStateMessage()">
            {{ getStateMessage() }}
         </p>
      </div>
   </div>

   <ng-container *ngIf="isRiskState()">
      <div
         class="risk-summary-overview"
         *ngIf="getCombinedSummary() || getCombinedRecommendedAction()"
      >
         <p class="combined-summary" *ngIf="getCombinedSummary()">
            {{ getCombinedSummary() }}
         </p>

         <div class="recommended-action" *ngIf="getCombinedRecommendedAction()">
            <div class="recommended-action-label">Recommended action</div>

            <div class="recommended-action-text">
               {{ getCombinedRecommendedAction() }}
            </div>
         </div>
      </div>

      <div
         class="risk-summary-statistics"
         *ngIf="
            hasRiskCount() ||
            hasAffectedRowCount() ||
            hasTotalRiskValue() ||
            hasHighestSeverity()
         "
      >
         <div class="risk-stat" *ngIf="hasRiskCount()">
            <div class="risk-stat-label">Risk Count</div>
            <div class="risk-stat-value">
               {{ getRiskCount() }}
            </div>
         </div>

         <div class="risk-stat" *ngIf="hasAffectedRowCount()">
            <div class="risk-stat-label">Affected Rows</div>
            <div class="risk-stat-value">
               {{ getAffectedRowCount() }}
            </div>
         </div>

         <div class="risk-stat" *ngIf="hasTotalRiskValue()">
            <div class="risk-stat-label">Total Risk Value</div>
            <div class="risk-stat-value">
               {{ formatRiskValue(getTotalRiskValue()) }}
            </div>
         </div>

         <div class="risk-stat" *ngIf="hasHighestSeverity()">
            <div class="risk-stat-label">Highest Severity</div>

            <div class="risk-stat-value risk-stat-severity">
               <span
                  class="severity-badge"
                  [ngClass]="getSeverityClass(getHighestSeverity())"
               >
                  {{ getHighestSeverity() }}
               </span>
            </div>
         </div>
      </div>

      <div class="risk-details" *ngIf="hasDetails()">
         <button
            type="button"
            class="risk-details-toggle"
            (click)="toggleDetails()"
            [attr.aria-expanded]="isDetailsExpanded"
            aria-controls="report-risk-detail-items"
         >
            <span>
               {{ isDetailsExpanded ? 'Hide risk details' : 'View risk details' }}
            </span>

            <i
               class="pi"
               [ngClass]="isDetailsExpanded ? 'pi-chevron-up' : 'pi-chevron-down'"
               aria-hidden="true"
            ></i>
         </button>

         <div
            id="report-risk-detail-items"
            class="risk-detail-items"
            *ngIf="isDetailsExpanded"
         >
            <article
               class="risk-detail-item"
               *ngFor="
                  let item of getItems();
                  let i = index;
                  trackBy: trackByRiskItem
               "
            >
               <div class="risk-detail-header">
                  <div class="risk-detail-title-area">
                     <h4>{{ getItemTitle(item) }}</h4>

                     <div class="risk-code" *ngIf="item.RiskCode">
                        {{ item.RiskCode }}
                     </div>
                  </div>

                  <div class="risk-detail-badges">
                     <span
                        class="severity-badge"
                        *ngIf="item.Severity"
                        [ngClass]="getSeverityClass(item.Severity)"
                     >
                        {{ item.Severity }}
                     </span>

                     <span class="category-badge" *ngIf="item.Category">
                        {{ item.Category }}
                     </span>
                  </div>
               </div>

               <div
                  class="risk-detail-statistics"
                  *ngIf="
                     hasItemNumber(item.Count) ||
                     hasItemNumber(item.FindingCount) ||
                     hasItemNumber(item.RiskValue)
                  "
               >
                  <div class="risk-detail-stat" *ngIf="hasItemNumber(item.Count)">
                     <span class="label">Count</span>
                     <span class="value">{{ item.Count }}</span>
                  </div>

                  <div
                     class="risk-detail-stat"
                     *ngIf="hasItemNumber(item.FindingCount)"
                  >
                     <span class="label">Findings</span>
                     <span class="value">
                        {{ item.FindingCount }}
                     </span>
                  </div>

                  <div class="risk-detail-stat" *ngIf="hasItemNumber(item.RiskValue)">
                     <span class="label">Risk Value</span>
                     <span class="value">
                        {{ formatRiskValue(item.RiskValue) }}
                     </span>
                  </div>
               </div>

               <p class="risk-detail-summary" *ngIf="item.Summary">
                  {{ item.Summary }}
               </p>

               <div class="risk-detail-action" *ngIf="item.RecommendedAction">
                  <span class="label"> Recommended action: </span>

                  <span class="value">
                     {{ item.RecommendedAction }}
                  </span>
               </div>
            </article>
         </div>
      </div>
   </ng-container>
</section>
